// MapComponent.js

import './Map.css';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { NavigationControl, ScaleControl, FullscreenControl  } from 'maplibre-gl';
import EduInInfo from './EduInInfo';
import * as turf from '@turf/turf';
import supercluster from 'supercluster';
import SearchBar from './SearchBar';
import { MaplibreExportControl, Size, PageOrientation, Format, DPI} from "@watergis/maplibre-gl-export";
import '@watergis/maplibre-gl-export/dist/maplibre-gl-export.css';

//Importing baselayer icons from src
import defaultBaselayer from './assets/default.png';
import streetBaselayer from './assets/streets-v2.png';
import satelliteBaselayer from './assets/satellite.png';

const MapComponent = ({isEnglish, latestDistrict, latestPalika,onMapClick, onMapClick1, mapstate }) => {

  const navigate = useNavigate();
  const [map, setMap] = useState(mapstate);
  const [style, setStyle] = useState('/my-style.json')
  const [activeBaselayer, setActiveBaselayer] = useState('default');
  // const [markers, setMarkers] = useState([]);
  const popup = new maplibregl.Popup({
    closeButton: false,
    closeOnClick: false,
  });

  const handleBaselayerToggle = (baselayer) => {
    setActiveBaselayer(baselayer);
    if (baselayer === 'street') {
      setStyle('https://api.maptiler.com/maps/streets-v2/style.json?key=Otbh9YhFMbwux7HyoffB');
    } else if (baselayer === 'default') {
      setStyle('/my-style.json');
    } else if (baselayer === 'satellite') {
      setStyle('https://api.maptiler.com/maps/satellite/style.json?key=Otbh9YhFMbwux7HyoffB');
    }
  };

  // Create separate instances of popups
  const adminBoundaryPopup = new maplibregl.Popup({ closeButton: false, closeOnClick: false });
  const palikaPopup = new maplibregl.Popup({ closeButton: false, closeOnClick: false });

  // Keep track of the currently active popup
  let activePopup = null;
  useEffect(() => {
   if(map){ 
   setMap(null)
   }
  },[style]);


  
  useEffect(() => {
  const calculateZoomLevel = () => {
    const deviceWidth = window.innerWidth;
    return deviceWidth < 768 ? 6.5 : 7.4;
  };

  // https://api.maptiler.com/maps/streets-v2/style.json?key=Otbh9YhFMbwux7HyoffB
    if (!map) {
      
        
        const initializedMap = new maplibregl.Map({
          container: 'map',
          style: style,
          center: [80.9871, 29.4988],
          zoom: calculateZoomLevel(),
          pitch: 30, // set the pitch to 45 degrees for a 3D effect
        });
        // initializedMap.addControl(new ScaleControl(), 'bottom-left');
        initializedMap.addControl(new NavigationControl(), 'top-left');
        initializedMap.addControl(new FullscreenControl(), 'bottom-right'); // Add FullscreenControl
        initializedMap.addControl(new MaplibreExportControl({
          PageSize: Size.A3,
          PageOrientation: PageOrientation.Portrait,
          Format: Format.PNG,
          DPI: DPI[96],
          Crosshair: true,
          PrintableArea: true
        }), 'bottom-right');
        setMap(initializedMap);
       
    
    }


 
  }, [map, latestDistrict,latestPalika]);
  // ... (Previous code)

useEffect(() => {
  const calculateZoomLevel = () => {
    const deviceWidth = window.innerWidth;
    return deviceWidth < 768 ? 6.5 : 7.4;
  };
  if (map) {
    const zoomToDistrictAndPalika = async () => {
      try {
        // Check if both latestDistrict and latestPalika are empty
        if (!latestDistrict && !latestPalika) {
          // Reset the map if both are empty
          map.flyTo({
            center: [80.9871, 29.4988],
            zoom: calculateZoomLevel(),
            pitch: 30,
            essential: true,
          });
        } else {
          // Continue with the zoom logic if either latestDistrict or latestPalika is present
          const response = await fetch('/supa_palikas.geojson');
          const geojson = await response.json();

          const filteredFeatures = geojson.features.filter((feature) => (
            feature.properties.DISTRICT === latestDistrict &&
            feature.properties.GaPa_NaPa === latestPalika
          ));

          if (filteredFeatures.length > 0) {
            const bounds = turf.bbox(turf.featureCollection(filteredFeatures));
            map.fitBounds(bounds, { padding: 20 });
          }
        }
      } catch (error) {
        console.error('Error loading GeoJSON:', error);
      }
    };

    zoomToDistrictAndPalika();
  }
}, [latestDistrict, latestPalika, map]);

// ... (Remaining code)


  useEffect(() => {
    if (map) {
 
   
      map.on('load', () => {
        map.addSource('local', {
          type: 'geojson',
          data: '/supa_districts.geojson',
        });

        map.addLayer({
          id: 'administrative_boundary_line',
          type: 'line',
          source: 'local',
          paint: {
            'line-color': 'blue',
            'line-width': {
              stops: [
                [1, 0.2],
                [6, 2],
                [14, 3],
                [22, 3],
              ],
            },
            'line-opacity': {
              stops: [
                [3, 0.5],
                [6, 1],
              ],
            },
            'line-dasharray': [2, 2],
          },
        });

        map.addLayer({
          id: 'administrative_boundary_fill',
          type: 'fill',
          source: 'local',
          paint: {
            'fill-color': 'blue',
            'fill-opacity': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                0,
                0.1
            ]
          },
        });
  

        // Add supa_palikas layer
        map.addSource('supa-palikas-source', {
          type: 'geojson',
          data: '/supa_palikas.geojson', // Update with the correct path
        });

        map.addLayer({
          id: 'supa_palika_fill',
          type: 'fill',
          source: 'supa-palikas-source',
          paint: {
            'fill-color': ' blue', // Adjust the color as needed
            'fill-opacity': [
              'case',
              ['boolean', ['feature-state', 'hover'], false],
              0,
              0.1
          ]
          },
        });

        map.addLayer({
          id: 'supa_palika_line',
          type: 'line',
          source: 'supa-palikas-source',
          paint: {
            'line-color': 'blue',
            'line-width': {
              stops: [
                [1, 0],
                [8, 0.1],
                [9, 1.5],
                [22, 2],
              ]},
            'line-opacity': {
              stops: [
                [3, 0],
                [8, 0.1],
                [9,1],
                [22,1]
              ],
            },
          },
        });
       
        map.on('click', 'administrative_boundary_fill', (e) => {
          const features = map.queryRenderedFeatures(e.point, { layers: ['administrative_boundary_fill'] });
         
          if (features.length > 0) {
            const clickedFeature = features[0];
            const clickedDistrict = clickedFeature.properties.DISTRICT;
        
     
            
        
            // Call the appropriate callback function based on the condition
            if (!latestDistrict&& onMapClick) {
              // If latestDistrict is empty and onMapClick is defined, call onMapClick
              onMapClick(clickedDistrict);
            }
          }
        });
        
      
        
      

        return () => {
          map.remove();
        };
      });
    }
  }, [map, latestDistrict, latestPalika]);

  useEffect(() => {
    
  
    if (map) {
      
      let hoveredStateId = null;
      let hoveredStateId1 = null;
          if (!latestDistrict) {
     
        map.on('mousemove', 'administrative_boundary_fill', (e) => {
          const features = map.queryRenderedFeatures(e.point, { layers: ['administrative_boundary_fill'] });
       
          handleHover(features, e, 'administrative_boundary');
          
          if (features.length > 0) {
            if (hoveredStateId) {
                map.setFeatureState(
                    {source: 'local', id: hoveredStateId},
                    {hover: false}
                );
            }
  
            hoveredStateId = features[0].id;
            map.setFeatureState(
                {source: 'local', id: hoveredStateId},
                {hover: true}
            );
        }
        });
  
        map.on('mouseout', 'administrative_boundary_fill', () => {
          hidePopup();
          if (hoveredStateId) {
            map.setFeatureState(
                {source: 'local', id: hoveredStateId},
                {hover: false}
            );
        }
   
      
          
        });

      }
     
      else   {
        map.on('mousemove', 'supa_palika_fill', (e) => {
          const features = map.queryRenderedFeatures(e.point, { layers: ['supa_palika_fill'] });
            // Check if the condition is met

           
          handleHover(features, e, 'supa_palika');
  
  
          // Change opacity of the hovered feature
          if (features.length > 0) {
            if (hoveredStateId1) {
                map.setFeatureState(
                    {source: 'supa-palikas-source', id: hoveredStateId1},
                    {hover: false}
                );
            }
  
            hoveredStateId1 = features[0].id;
        
            map.setFeatureState(
                {source: 'supa-palikas-source', id: hoveredStateId1},
                {hover: true}
            );
        }
        });
  
        map.on('mouseout', 'supa_palika_fill', () => {
          hidePopup();
          if (hoveredStateId1) {
            map.setFeatureState(
                {source: 'supa-palikas-source', id: hoveredStateId1},
                {hover: false}
            );
        }
          
        });
      
    }}
  }, [map, latestDistrict, latestPalika]);
  


  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetch('/supa_palikas.geojson');
        const geojson = await response.json();

        let filteredFeatures = [];
        map.on('click', 'supa_palika_fill', (e) => {
          const features = map.queryRenderedFeatures(e.point, { layers: ['supa_palika_fill'] });
        
          if (features.length > 0) {
            const clickedFeature = features[0];
            const clickedPalika = clickedFeature.properties.GaPa_NaPa;
        
            if (clickedFeature.properties.DISTRICT == latestDistrict)
        {
            // Call the appropriate callback function based on the condition
            if (onMapClick1) {
              console.log(clickedPalika)
              
              // If latestDistrict has some value and onMapClick2 is defined, call onMapClick2
              onMapClick1(clickedPalika);
            }
          }
          }
        });

        if (latestDistrict ) {
            
          filteredFeatures = geojson.features.filter(feature => (
            feature.properties.DISTRICT === latestDistrict

          ));
        }

        if (latestPalika) {
          filteredFeatures = filteredFeatures.filter(feature => (
            feature.properties.GaPa_NaPa === latestPalika
          ));
        }

        if (filteredFeatures.length > 0) {
          const bounds = turf.bbox(turf.featureCollection(filteredFeatures));
          map.fitBounds(bounds, { padding: 20 });
         

          map.getSource('supa-palikas-source').setData({
            type: 'FeatureCollection',
            features: filteredFeatures,
          });
        }
      } catch (error) {
        console.error('Error loading GeoJSON:', error);
      }
    };

    loadData();
  }, [latestDistrict, latestPalika, map]);

  // First useEffect for zooming to district and palika
useEffect(() => {
  if (map) {
    const zoomToDistrictAndPalika = async () => {
      try {
        const response = await fetch('/supa_palikas.geojson');
        const geojson = await response.json();

        const filteredFeatures = geojson.features.filter(feature => (
          feature.properties.DISTRICT === latestDistrict &&
          feature.properties.GaPa_NaPa === latestPalika
        ));

  

        if (filteredFeatures.length > 0) {
          const bounds = turf.bbox(turf.featureCollection(filteredFeatures));
          map.fitBounds(bounds, { padding: 20 });
        }
      } catch (error) {
        console.error('Error loading GeoJSON:', error);
      }
    };

    zoomToDistrictAndPalika();
  }
}, [latestDistrict, latestPalika, map]);

// Second useEffect for loading markers on the map
useEffect(() => {
  const loadMarkersOnMap = async () => {
    if (map) {
      try {
        

        // Fetch additional data
        const additionalDataResponse = await fetch(`https://backend.mappersnepal.com.np/schools/`);
        const additionalData = await additionalDataResponse.json();

      
        // Create a supercluster instance
        const cluster = new supercluster({
          radius: 40, // Adjust the clustering radius as needed
          maxZoom: 16, // Maximum zoom level for clustering
        });
      
      

        // Load data into the supercluster instance
        cluster.load(additionalData.map(item => ({
          type: 'Feature',
          properties: { cluster_id: additionalData.indexOf(item), schoolName: item.SCHOOL_NAME },
          geometry: {
            type: 'Point',
            coordinates: [parseFloat(item.X_LONGITUDE), parseFloat(item.X_LATITUDE)],
          },
        })));



        // Generate clusters and markers
        const clusters = cluster.getClusters([-180, -90, 180, 90], map.getZoom());


        const markers = clusters.map(cluster => {
          if (cluster.properties.cluster) {
            // Cluster marker with label
            const marker = new maplibregl.Marker()
              .setLngLat(cluster.geometry.coordinates)
              .setPopup(new maplibregl.Popup({ offset: 25 }).setHTML(`<p>${cluster.properties.point_count} schools</p>`));

            // Custom HTML element for cluster label
            const clusterLabel = document.createElement('div');
            clusterLabel.className = 'cluster-label';
            clusterLabel.textContent = cluster.properties.point_count;

            // Cluster label marker
            const labelMarker = new maplibregl.Marker(clusterLabel)
              .setLngLat(cluster.geometry.coordinates)
              .addTo(map);

            return marker;
          } else {
            // Single marker
            const itemIndex = cluster.properties.cluster_id; // Use cluster_id instead of index
            const item = additionalData[itemIndex];
  
            if (item) {
              const popupContent = `
                <div class="popup-container">
                  <p class="popup-content"><strong>School Name:</strong> ${item.SCHOOL_NAME}</p>
                  <button id="seeDashboardBtn">
                    <i class="fas fa-chart-line dashboard-icon"></i>See Dashboard
                  </button>
                </div>
              `;
              const popup = new maplibregl.Popup({ offset: 25 })
                .setHTML(popupContent)
                .on('open', () => {
                  const seeDashboardBtn = document.getElementById('seeDashboardBtn');
                  if (seeDashboardBtn) {
                    seeDashboardBtn.addEventListener('click', () => {
                      console.log(item)
                      navigate('/edu', { state: { item } });
                    });
                  }
                });

              // Single marker
              return new maplibregl.Marker()
                .setLngLat(cluster.geometry.coordinates)
                .setPopup(popup);
            } else {
              console.error("Error: item is undefined for cluster:", cluster);
              console.log("Additional Data:", additionalData);
              console.log("Cluster Properties:", cluster.properties);
              console.log("Item Index:", itemIndex);
              return null;
            }
          }
        });

        // Add the markers to a new source on the map
        markers.filter(marker => marker !== null).forEach(marker => marker.addTo(map));

       

      } catch (error) {
        console.error('Error loading markers:', error);
      }
    }
  };

  // Load markers on map when the map is ready
  loadMarkersOnMap();

  // Re-load markers when the map zoom changes
  if (map) {
    map.on('zoomend', loadMarkersOnMap);
  }

}, [map]);








  const hoverPopup = new maplibregl.Popup({ closeButton: false, closeOnClick: true });

  let previousFeatureId = null; // Initialize the previous feature ID outside the function

  const handleHover = async (features, e, layer) => {
      if (features.length > 0) {
          const feature = features[0];
          
          // Check if the current feature ID is the same as the previous one
          if (feature.id !== previousFeatureId) {
              const coordinates = e.lngLat;
              let indicator = ''; // Initialize indicator
              let key = ''; // Initialize key
              let apiUrl = ''; // Initialize API URL
              let school = '';
  
              if (layer === 'administrative_boundary') {
                  indicator = feature.properties.DISTRICT;
                  apiUrl = `https://backend.mappersnepal.com.np/hoverdistrict/${indicator}/`;
                  key = 'District';
              } else if (layer === 'supa_palika') {
                  indicator = feature.properties.GaPa_NaPa;
                  apiUrl = `https://backend.mappersnepal.com.np/hoverpalika/${indicator}/`;
                  key = 'Palika';
              }
  
              try {
                  // Make API call
                  const response = await fetch(apiUrl);
                  if (!response.ok) {
                      throw new Error('Failed to fetch data');
                  }
  
                  // Parse API response
                  const data = await response.json();
                  school = data; // Update 'school' with the data from the API
  
                  const popupContent = generatePopupContent(layer, indicator, key, school);
                  showPopup(coordinates, popupContent, layer);
  
                  // Update the previous feature ID
                  previousFeatureId = feature.id;
              } catch (error) {
                  console.error('Error fetching data:', error);
                  hidePopup();
              }
          } else {
              // Same feature as before, do nothing
          }
      } else {
          hidePopup();
          // Reset the previous feature ID when there's no feature
          previousFeatureId = null;
      }
  };
  
  

  const generatePopupContent = (layer, indicator, key, school) => {
    
      return `<p class="popup-data-type"><strong>Educational Institutes Number</strong></p>
              <div class="popup-container">
                <div class="popup-info-container">
                  <p class="popup-info"><strong>${key}:</strong> ${indicator}</p>
                </div>
                <div class="popup-circle">
                  <p class="popup-education">
                    <strong>${school}</strong>
                  </p>
                </div>
              </div>`;
   
  };

  const showPopup = (coordinates, content, layer) => {
    hidePopup();

    if (layer === 'administrative_boundary' && latestPalika=='') {
      adminBoundaryPopup.setLngLat(coordinates).setHTML(content).addTo(map);
      activePopup = adminBoundaryPopup;
    } else if (layer === 'supa_palika' && latestPalika=='') {
      palikaPopup.setLngLat(coordinates).setHTML(content).addTo(map);
      activePopup = palikaPopup;
    }
  };

  const hidePopup = () => {
    if (activePopup) {
      activePopup.remove();
      activePopup = null;
    }
  };
  const handleSearchResultClick = (coordinates) => {
    // Handle the click on a search result, using the coordinates
    // You can perform any logic here, such as centering the map on the clicked location
    // Example: map.flyTo({ center: [coordinates.longitude, coordinates.latitude], zoom: 14 });
  console.log(coordinates)
    if (map) {
      // Center the map on the clicked coordinates
      map.flyTo({
        center: [parseFloat(coordinates.longitude), parseFloat(coordinates.latitude)],
        zoom: 20,
        essential: true,
      });
    }
  };


  return (
    <div id="map">
    <SearchBar
        isEnglish={isEnglish}
        onSearchResultClick={handleSearchResultClick}
      />
      <div className='baselayer_toggle'>
      <button title='switch to default baselayer'
        className={activeBaselayer === 'default' ? 'active' : ''}
        onClick={() => handleBaselayerToggle('default')}
      >
        <img src={defaultBaselayer} alt="Default Baselayer" />
      </button> 
      <button  title='switch to street baselayer'
        className={activeBaselayer === 'street' ? 'active' : ''}
        onClick={() => handleBaselayerToggle('street')}
      >
        <img src={streetBaselayer} alt="Street Baselayer" />
      </button>
      <button  title='switch to satellite baselayer'
        className={activeBaselayer === 'satellite' ? 'active' : ''}
        onClick={() => handleBaselayerToggle('satellite')}
      >
        <img src={satelliteBaselayer} alt="Satellite Baselayer" />
      </button>
      </div>
    </div>
  );
};

export default MapComponent;
